import { encodeLoad, decodeLoad } from '@/lib/base64.js'

import Compressor from 'compressorjs'
const { adminStore } = await import('@/stores/adminstore.js')
const { userStore } = await import('@/stores/userstore.js')

export const imageActions = {
  async savePictureFromFile(fileObject) {
    return new Promise((resolve) => {
      let self = this
      console.log('*** savePictureFromFile GOT CALLED ! (%j)', fileObject)
      let reader = new FileReader()
      reader.readAsDataURL(fileObject)
      console.log(reader)
      reader.onloadend = function() {
        let imageSrc = reader.result
        new Compressor(dataURItoBlob(imageSrc), {
          quality: 0.6,
          mimeType: 'image/webp',
          convertTypes: ['image/png', 'image/webp'],
          success(cimg) {
            console.log('===== COMPRESSOR SUCCESS')
            console.log(cimg)
            //  console.log(imgToSave)
            let filer = new FileReader()
            filer.readAsDataURL(cimg) // converts the blob to base64 and calls onload
            filer.onloadend = function() {
              let imgToSaveCompressed = filer.result
              console.log(imgToSaveCompressed)
              self.saveImage(imgToSaveCompressed).then((result) => {
                console.log('SAVE IMAGE RETURNED (%j)', result)
                if (result.success) {
                  resolve({
                    success: true,
                    data: result.data
                  })
                }
              })
            }
          },
          error(err) {
            console.error(err)
          }
        }) // compressor
      }
    }) // Promise
  },
  async saveImageFromFile(fileObject) {
    console.log('Save saveImageFromFile got called ')
    return new Promise((resolve) => {
      let payload = {
        fileName:
          fileObject.name ||
          this.primaryMode.displayName.trim().replace(' ', '_'),
        mimeType: fileObject.type || 'image/webp' //this.mimeType
      }
      this.setImageProperties7(payload)
      this.savePictureFromFile(fileObject).then((result) => {
        console.log('RESULT FROM SAVE PICTURE')
        console.log(result)
        if (result.success) {
          //this.primaryModel.picture = result.data.storeName;
          resolve({
            success: true,
            storeName: result.data.storeName
          })
          //   this.isSaving = false;
        } else {
          // savePrimary
          resolve({
            success: false,
            error: true
          })
        }
      }) // savePictureFromFile
    }) // promise
  },
  async saveImage(imageToSave) {
    console.log('Save Image got called ')
    console.log(imageToSave)
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      let imageByteArray = convertDataURIToBinary(imageToSave)
      let formData = new FormData()
      // console.log('IMAGE BYTE ARRAY (%s)', imageByteArray)
      // console.log(imageByteArray)
      //      let imageBlob = new Blob([imageByteArray], { type: this.mimeType })
      let imageBlob = new Blob([imageByteArray], { type: this.mimeType })
      console.log('IMAGE BLOB filename(%s)', this.fileName)
      console.log(imageBlob)
      formData.append('files', imageBlob, this.fileName)
      formData.append('gogl', true)
      console.log('FORM DATA (%j)', formData)
      aStore
        .postHTTPForm('imageupload/upload', formData)
        .then((response) => {
          console.log('Success!', response)
          let responseData = response.data || {}
          if (responseData.success) {
            let uploaded = responseData.uploaded || []
            if (uploaded.length !== 1) {
              console.error(
                '*** ERROR *** more than one picture was uploaded...'
              )
              resolve({
                success: false,
                error: true,
                errorMsg: '*** ERROR *** more than one picture was uploaded...'
              })
            }

            resolve({
              success: true,
              data: uploaded[0]
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async deleteImage(image, library) {
    console.log('DELETE Image got called (%s)', image.image_imageurl)
    console.log(image)
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    let pLoad = {
      fileName: encodeLoad(image.image_imageurl),
      gogl: true
    }
    return new Promise((resolve) => {
      aStore
        .postHTTP('imageupload/delete', pLoad)
        .then((response) => {
          console.log('DELETE IMAGE RETURNED (%j)', response)
          let responseData = response.data || {}
          if (responseData.success) {
            this.removeImageFromLibrary(image, library).then(() => {
              resolve({
                success: true
              })
            })
          } else {
            resolve({
              success: false,
              error: true,
              errorMsg: 'Could not delete image '
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async removeImageFromLibrary(image, library) {
    console.log('removeImageFromLibrary got called !')
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let uStore = userStore()
      let pUser = uStore.primaryuser
      console.log('image Uid (%s)', image.uid)
      console.log('library Uid (%s)', library.uid)
      let deleteLoad =
        `<${image.uid}> * * . \n` +
        `<${library.uid}> <il_hasImages> <${image.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/imagetolibrary', pLoad)
        .then((result) => {
          console.log('delete image from library returned ', result)
          this.getPictureGalleries().then((res) => {
            this.activepicturegallery = res.data
            resolve({
              success: true,
              data: res.data
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete primary had some problems..')
          console.log(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },

  async removeImageLibrary(library) {
    console.log('removeImageFromLibrary got called !')
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let uStore = userStore()
      let pUser = uStore.primaryuser
      console.log('pUser Uid (%s)', pUser.uid)
      console.log('library Uid (%s)', library.uid)
      let deleteLoad =
        `<${library.uid}> * * . \n` +
        `<${pUser.uid}> <pu_hasImageLibrary> <${library.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/imagetolibrary', pLoad)
        .then((result) => {
          console.log('delete image from library returned ', result)
          this.getPictureGalleries().then((res) => {
            this.activepicturegallery = res.data
            resolve({
              success: true,
              data: res.data
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete primary had some problems..')
          console.log(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async saveVideo(videoToSave) {
    console.log('Save Video got called ')
    console.log(videoToSave)
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      let imageByteArray = convertDataURIToBinary(videoToSave)
      let formData = new FormData()
      // console.log('IMAGE BYTE ARRAY (%s)', imageByteArray)
      // console.log(imageByteArray)
      //      let imageBlob = new Blob([imageByteArray], { type: this.mimeType })
      let imageBlob = new Blob([imageByteArray], { type: this.videoMimeType })
      console.log('IMAGE BLOB')
      console.log(imageBlob)
      formData.append('files', imageBlob, this.videoFileName)
      formData.append('gogl', true)
      console.log('FORM DATA (%j)', formData)
      aStore
        .postHTTPForm('imageupload/upload', formData)
        .then((response) => {
          console.log('Success!')
          console.log({ response })
          let responseData = response.data || {}
          if (responseData.success) {
            let uploaded = responseData.uploaded || []
            if (uploaded.length !== 1) {
              console.error(
                '*** ERROR *** more than one picture was uploaded...'
              )
              resolve({
                success: false,
                error: true,
                errorMsg: '*** ERROR *** more than one picture was uploaded...'
              })
            }

            resolve({
              success: true,
              data: uploaded[0]
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async newImageLibrary(payload) {
    console.log('newImageLibrary ')
    console.log(payload)
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/createImageLibrary/newImageLibrary', pLoad)
        .then((response) => {
          console.log('createImageLibrary returned!')
          console.log(response)
          let responseData = response.data || {}
          if (responseData.success) {
            resolve({
              success: true,
              data: response.data
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async addImageToLibrary(payload) {
    console.log('addImageToLibrary ')
    console.log(payload)
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/addImageToLibrary/imageToLibrary', pLoad)
        .then((response) => {
          console.log('addImageToLibrary returned!')
          console.log(response)
          let responseData = response.data || {}
          if (responseData.success) {
            this.getPictureGalleries().then((res) => {
              console.log(
                'SAVE IMAGE TO LIBRARY - GET PICTURE GALLERY (%j)',
                res
              )
              this.activepicturegallery = res.data
              resolve({
                success: true,
                data: response.data
              })
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },

  async storeImagesToMemoryGame(payload) {
    console.log('storeImagesToMemoryGame ')
    console.log(payload)
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    let aStore = adminStore()
    let uStore = userStore()
    let pUser = uStore.primaryuser
    return new Promise((resolve) => {
      let load = {
        memoryGameImages: payload,
        primaryUserUid: pUser.uid
      }
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(load)),
        gogl: true
      }
      aStore
        .postHTTP('memas/addImagesMemoryGame/storeImagesToMemoryGame', pLoad)
        .then((response) => {
          console.log('addImageToLibrary returned!')
          console.log(response)
          let responseData = response.data || {}
          if (responseData.success) {
            this.getPictureGalleries().then((res) => {
              console.log(
                'SAVE IMAGE TO LIBRARY - GET PICTURE GALLERY (%j)',
                res
              )
              this.activepicturegallery = res.data
              resolve({
                success: true,
                data: response.data
              })
            })
          }
        })
        .catch((error) => {
          console.log({ error })
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  setImageProperties(payload) {
    console.log('setImage Properties (%j)', payload)
    this.mimeType = payload.mimeType
    this.fileName = payload.fileName
  },
  setVideoProperties(payload) {
    console.log('setVideoProperties Properties (%j)', payload)
    this.videoMimeType = payload.mimeType
    this.videoFileName = payload.fileName
  },
  async getImageUrl(imageid) {
    let aStore = adminStore()
    if (imageid) {
      console.log(
        'getImageUrl: ',
        `${aStore.serverurl}imagedownload/image/${imageid}`
      )
      return `${aStore.serverurl}imagedownload/image/${imageid}`
    } else {
      return ''
    }
  },
  async getVideoUrl(imageid) {
    //    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return `${aStore.serverurl}imagedownload/video/${imageid}`
  },
  async deleteGoogleBucketFile(filename) {
    // let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      if (filename === '') {
        resolve({ success: true, msg: 'noFilename specified' })
      }
      let pLoad = {
        fileName: encodeLoad(filename),
        gogl: true
      }
      aStore
        .postHTTP('imageupload/delete', pLoad)
        .then((result) => {
          console.log('delete FILE FROM BUCKET returned ', result)
          resolve({
            success: true,
            data: result
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete primary had some problems..')
          console.log(error)
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async getPictureGalleries() {
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    let aStore = adminStore()
    let uStore = userStore()
    let pUser = uStore.primaryuser
    return new Promise((resolve) => {
      let load = `{
        query(func: uid(${pUser.uid})) {
           uid
           pu_hasImageLibrary {
            uid
            il_title
            il_hasImages {
              uid
              image_description
              image_imageurl
            }
           }
        }
    } `
      let pLoad = {
        query: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dquery/pictureGalleries', pLoad)
        .then((response) => {
          console.log('pictureGalleries user respons (%j)', response)
          resolve({ success: true, data: response.data.dgraphresult })
        })
        .catch((err) => {
          console.log('** ERROR ** pictureGalleries user respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // then
    }) // promise
  },
  async getMemoryGameImages() {
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    let aStore = adminStore()
    let uStore = userStore()
    let pUser = uStore.primaryuser
    return new Promise((resolve) => {
      let load = `{
      var(func: uid(${pUser.uid})) {
         pu_hasImageLibrary {
			  	il_hasImages {
	  		  	imageUid as uid
          }
        }
      }
  	    query(func: uid(imageUid)) {
			  uid
        image_description
        image_imageurl
        }
      }  `
      let pLoad = {
        query: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dquery/getMemoryGameImages', pLoad)
        .then((response) => {
          console.log('getMemoryGameImages  respons (%j)', response)
          resolve({ success: true, data: response.data.dgraphresult })
        })
        .catch((err) => {
          console.log('** ERROR ** getMemoryGameImages  respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // then
    }) // promise
  },
  async getImagesToMemoryGame() {
    // let { adminStore } = await import('@/stores/adminstore.js')
    // let { userStore } = await import('@/stores/userstore.js')
    let aStore = adminStore()
    let uStore = userStore()
    let pUser = uStore.primaryuser
    return new Promise((resolve) => {
      let load = `{
      query(func: uid(${pUser.uid})) {
         pu_hasBrainMemoryGameImages {
			  	image_description
          image_imageurl
          }
        }
      }  `
      let pLoad = {
        query: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dquery/getImagesToMemoryGame', pLoad)
        .then((response) => {
          console.log('getImagesToMemoryGame respons (%j)', response)
          resolve({ success: true, data: response.data.dgraphresult[0] })
        })
        .catch((err) => {
          console.log(
            '** ERROR ** getImagesToMemoryGame user respons (%j)',
            err
          )
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // then
    }) // promise
  },
  setActiveLibrary(libraryUid) {
    this.activelibrary = libraryUid
  }
  /* ************************************************************** */
  /* PICTURES */
  /* ************************************************************** */
}

function dataURItoBlob(dataURI) {
  let byteString = atob(dataURI.split(',')[1])
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  let ab = new ArrayBuffer(byteString.length)
  let ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  let blob = new Blob([ab], { type: mimeString })

  return blob
}

function convertDataURIToBinary(dataURI) {
  //  console.log('CONVERT DATA URI TO BINARY ')
  //  console.log(dataURI)
  let BASE64_MARKER = ';base64,'
  let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
  //  console.log('CONVERT DATA URI TO BINARY (%s)', base64Index)
  let base64 = dataURI.substring(base64Index)
  console.log('CONVERT DATA URI TO BINARY ')
  console.log(base64)
  let raw = window.atob(base64)
  let rawLength = raw.length
  let array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i)
  }
  return array
}
